export default __webpack_public_path__ + "static/media/Frostmaw Gauntlets.85b74f47.jpg";